import { useEffect, useState } from "react";
import { getControleDossierLotAttachmentContent } from "../../../../services/api";
import { iconButtonStyle } from "../styles/layoutStyles";

// Télécharge le contenu de la pièce jointe et l'expose en URL locale, révoquée au démontage.
function useAttachmentObjectUrl(dossierId, attachmentId) {
    const [objectUrl, setObjectUrl] = useState("");
    const [loadError, setLoadError] = useState("");

    useEffect(() => {
        let cancelled = false;
        let localUrl = "";
        setLoadError("");
        setObjectUrl("");

        if (!dossierId || !attachmentId) return undefined;
        getControleDossierLotAttachmentContent(dossierId, attachmentId)
            .then(response => {
                if (cancelled) return;
                localUrl = URL.createObjectURL(response.data);
                setObjectUrl(localUrl);
            })
            .catch(() => {
                if (!cancelled) setLoadError("Aperçu indisponible.");
            });

        return () => {
            cancelled = true;
            if (localUrl) URL.revokeObjectURL(localUrl);
        };
    }, [dossierId, attachmentId]);

    return { objectUrl, loadError };
}

function AttachmentPreviewBody({ attachment, objectUrl, loadError }) {
    const isPdf = String(attachment.contentType || "").includes("pdf") || String(attachment.fileName || "").toLowerCase().endsWith(".pdf");
    const isImage = String(attachment.contentType || "").startsWith("image/");
    if (loadError) return <div style={{ color: "#94a3b8", fontSize: "13px" }}>{loadError}</div>;
    if (!objectUrl) return <div style={{ color: "#94a3b8", fontSize: "13px" }}>Chargement...</div>;
    if (isPdf) return <iframe title={attachment.fileName || attachment.id} src={objectUrl} style={{ width: "100%", height: "100%", border: 0 }} />;
    if (isImage) return <img src={objectUrl} alt={attachment.fileName || "Document importé"} style={{ width: "100%", height: "100%", objectFit: "contain" }} />;
    return (
        <a href={objectUrl} target="_blank" rel="noreferrer" style={{ color: "#2563eb", fontWeight: 800 }}>
            Ouvrir le document
        </a>
    );
}

export function ControleAttachmentPreview({ dossierId, attachment, disabled, onDelete }) {
    const { objectUrl, loadError } = useAttachmentObjectUrl(dossierId, attachment?.id);
    const openDocument = () => {
        if (!objectUrl) return;
        window.open(objectUrl, "_blank", "noopener,noreferrer");
    };

    return (
        <div style={{
            display: "grid",
            gap: "8px",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #e2e8f0",
            background: "#f8fafc",
        }}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: "8px", alignItems: "center" }}>
                <div style={{ minWidth: 0 }}>
                    <button
                        type="button"
                        onClick={openDocument}
                        disabled={!objectUrl}
                        style={{
                            border: 0,
                            padding: 0,
                            background: "transparent",
                            color: objectUrl ? "#2563eb" : "#0f172a",
                            cursor: objectUrl ? "pointer" : "default",
                            fontSize: "13px",
                            fontWeight: 900,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "100%",
                            textAlign: "left",
                            textDecoration: objectUrl ? "underline" : "none",
                        }}
                        title={objectUrl ? "Ouvrir le document dans une nouvelle fenêtre" : "Chargement du document"}
                    >
                        {attachment.fileName || "Document"}
                    </button>
                    <div style={{ color: "#64748b", fontSize: "12px", marginTop: "2px" }}>
                        {attachment.contentType || "Fichier"}
                    </div>
                </div>
                <button
                    type="button"
                    disabled={disabled}
                    onClick={() => {
                        if (window.confirm("Supprimer ce document importé ?")) onDelete(attachment.id);
                    }}
                    style={{ ...iconButtonStyle, color: "#dc2626", flexShrink: 0, opacity: disabled ? 0.55 : 1 }}
                    title="Supprimer le document"
                >
                    ×
                </button>
            </div>

            <div style={{
                height: "360px",
                borderRadius: "8px",
                border: "1px solid #e2e8f0",
                background: "white",
                overflow: "hidden",
                display: "grid",
                placeItems: "center",
            }}>
                <AttachmentPreviewBody attachment={attachment} objectUrl={objectUrl} loadError={loadError} />
            </div>
        </div>
    );
}
